import '../components/vueData/vueData.element.js';
import '../components/product-family/product-family.element.js';
import '../components/tooltip/tooltip.js';
import '../components/scroll-to-top/scroll-to-top.js';
import '../components/anchor-link/anchor-link.element.js';
import { initLinks } from '../components/shop-link/shop-link.js';

initLinks(document.body);
